import { useMemo } from 'react';
import { useIsUserInRole, useUserInfo, selectedDatabaseIdState } from '@transport-insights/uikit';
import { useRecoilValue } from 'recoil';

// Hook to determine if the user has access based on their roles and the selected RCA

function useHasAccess(allowedRoles = ['View', 'User', 'Admin']) {
  const hasDeveloperRole = useIsUserInRole('Developer');
  const { roles } = useUserInfo();
  const rcaId = useRecoilValue(selectedDatabaseIdState);

  const hasAllowedRole = useMemo(() => {
    if (!roles || roles.length === 0) return false;

    return roles.some((role) => allowedRoles.some((allowedRole) => role.startsWith(`db:${rcaId}:${allowedRole}`)));
  }, [roles, rcaId, allowedRoles]);

  return hasAllowedRole || hasDeveloperRole;
}

export default useHasAccess;
